__turbopack_context__.v({
  "totalResults": "TotalResultsLabel-module__9SWPMG__totalResults",
});
